document.addEventListener("DOMContentLoaded", function () {
    function updateFilterLinks() {
        const currentParams = new URLSearchParams(window.location.search);
        
        currentParams.forEach((_, key) => {
            if (key.startsWith("page") || key.startsWith("tag")) {
                currentParams.delete(key);
            }
        });

        document.querySelectorAll('a.articles-filter-sort__filter__option').forEach(link => {
            const linkUrl = new URL(link.href, window.location.origin);

            currentParams.forEach((value, key) => {
                if (!linkUrl.searchParams.has(key)) {
                    linkUrl.searchParams.set(key, value);
                }
            });

            link.href = `${linkUrl.toString()}#posts`;
        });
    }

    updateFilterLinks();

    const filterOptions = document.querySelector(".articles-filter-sort__filter__options");
    if (filterOptions) {
        filterOptions.addEventListener("click", () => {
            let active = filterOptions.getAttribute("data-active") === "true";
            filterOptions.setAttribute("data-active", !active);
        });

        filterOptions.querySelectorAll("li").forEach((link) => {
            link.addEventListener("click", () => {
                filterOptions.querySelector('.articles-filter-sort__filter__options-button span').innerHTML = `${link.querySelector('a').innerHTML}`;
            });
        })
    }
});
